import { Location } from '@angular/common';
import { Component, Input } from '@angular/core';

import { ICONS_ENUM } from '@app/open-insurance/shared/constants/icons';

@Component({
  selector: 'app-opin-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})
export class OpinHeaderComponent {
  ICONS = ICONS_ENUM;

  @Input() title: string;

  constructor(private location: Location) {}

  goBackPage() {
    this.location.back();
  }
}
